import React, { useState, useEffect } from 'react'
import { FiX } from "react-icons/fi"
import { useNavigate } from 'react-router-dom'
import { CiMenuBurger } from "react-icons/ci"
import { FaDev } from "react-icons/fa"
import { Link } from 'react-scroll'
import '../css/header.css'
import { useT } from '../context/LanguageContext'

const NAV_ITEMS = [
  { id: 1, key: 'home',       url: 'home'    },
  { id: 2, key: 'about',      url: 'about'   },
  { id: 3, key: 'experience', url: 'mywork'  },
  { id: 4, key: 'work',       url: 'contact' },
]

function LangToggle() {
  const { lang, setLang } = useT()
  return (
    <div className="lang-toggle">
      {['en', 'es'].map(l => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`lang-btn ${lang === l ? 'lang-btn--active' : ''}`}
        >
          {l.toUpperCase()}
        </button>
      ))}
    </div>
  )
}

function Header() {
  const { t } = useT()
  const isHome = window.location.pathname === '/'
  const navigate = useNavigate()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY >= 65)
    window.addEventListener('scroll', handler)
    return () => window.removeEventListener('scroll', handler)
  }, [])

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [menuOpen])

  const closeMenu = () => setMenuOpen(false)

  return (
    <>
      <nav className={`h-nav${(scrolled || menuOpen) ? ' h-nav--scrolled' : ''}`}>
        <Link to='home' className='h-logo' onClick={closeMenu}>
          <FaDev size="2rem" style={{ color: 'rgba(255,255,255,0.9)' }} />
          <span className="h-logo-text">raulfr</span>
        </Link>

        {/* Desktop nav */}
        <div className="h-desktop-links">
          {isHome
            ? NAV_ITEMS.map(item => (
                <Link
                  key={item.id}
                  className="h-nav-link"
                  to={item.url}
                  spy={true}
                  offset={-80}
                  duration={150}
                >
                  {t.nav[item.key]}
                </Link>
              ))
            : (
                <a className="h-nav-link" href="/" onClick={e => { e.preventDefault(); navigate('/') }}>
                  {t.nav.home}
                </a>
              )
          }
        </div>

        {/* Desktop lang */}
        <div className="h-desktop-lang">
          <LangToggle />
        </div>

        {/* Mobile hamburger — only visible below 850px */}
        <button
          className="h-mobile-btn"
          onClick={() => setMenuOpen(v => !v)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        >
          {menuOpen
            ? <FiX size="1.5rem" style={{ color: 'rgba(255,255,255,0.85)' }} />
            : <CiMenuBurger size="1.4rem" style={{ color: 'rgba(255,255,255,0.85)' }} />
          }
        </button>
      </nav>

      {/* Mobile overlay menu */}
      <div className={`h-mobile-menu${menuOpen ? ' h-mobile-menu--open' : ''}`}>
        <div className="h-mobile-inner">
          <nav className="h-mobile-links">
            {isHome
              ? NAV_ITEMS.map((item, i) => (
                  <Link
                    key={item.id}
                    className="h-mobile-link"
                    to={item.url}
                    spy={true}
                    offset={-80}
                    duration={150}
                    onClick={closeMenu}
                    style={{ transitionDelay: menuOpen ? `${i * 50}ms` : '0ms' }}
                  >
                    <span className="h-mobile-link-num">0{i + 1}</span>
                    {t.nav[item.key]}
                  </Link>
                ))
              : (
                  <a className="h-mobile-link" href="/" onClick={e => { e.preventDefault(); closeMenu(); navigate('/') }}>
                    <span className="h-mobile-link-num">01</span>
                    {t.nav.home}
                  </a>
                )
            }
          </nav>

          <div className="h-mobile-footer">
            <span className="h-mobile-footer-label">Language</span>
            <LangToggle />
          </div>
        </div>
      </div>
    </>
  )
}

export default Header
